import { render, staticRenderFns } from "./CoozzyCountSpan.vue?vue&type=template&id=3c2dcfda&scoped=true"
import script from "./CoozzyCountSpan.vue?vue&type=script&lang=js"
export * from "./CoozzyCountSpan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2dcfda",
  null
  
)

export default component.exports